/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import colors from "../../base/colors";
import typography from "../../base/typography";

// Material Dashboard 2 React Helper Functions
import pxToRem from "../../functions/pxToRem";

const { transparent, light, info, secondary, primary } = colors;
const { size } = typography;

const outlined = {
  base: {
    // minHeight: pxToRem(40),
    // color: light.main,
    color: "white",
    // borderColor: light.main,
    borderColor: "white ",
    borderWidth: "1px !important",
    padding: `${pxToRem(16)} ${pxToRem(20)}`,
    maxHeight: "fit-content !important",
    fontFamily: "Inter",
    fontWeight: "400",

    "&:hover": {
      backgroundColor: transparent.main,
      boxShadow: 1,
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    // minHeight: pxToRem(32),
    padding: `${pxToRem(6)} ${pxToRem(16)}`,
    fontSize: size.xs,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    // minHeight: pxToRem(47),
    padding: `${pxToRem(28)} ${pxToRem(28)}`,
    fontSize: size.sm,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: {
    backgroundColor: transparent.main,
    borderColor: secondary.main,
    color: secondary.main,
    "&:hover": {
      backgroundColor: secondary.main,
      borderColor: secondary.main,
      color: "white",
    },
  },

  secondary: {
    backgroundColor: transparent.main,
    borderColor: secondary.main,

    "&:hover": {
      backgroundColor: transparent.main,
    },
  },
};

export default outlined;
